import { z } from 'zod';
import { trimToUndefined } from '../TypescriptService';
export const ESCANDALLOS_QUALIFICATION_VALUES = [
    'Nunca',
    'Estoy en ello ahora mismo',
    'Hace 3 meses',
    'Hace 6 meses',
    'Más de un año',
];
export const normalizeEscandallosQualification = (value) => {
    const trimmed = trimToUndefined(value);
    if (!trimmed)
        return undefined;
    return ESCANDALLOS_QUALIFICATION_VALUES.includes(trimmed)
        ? trimmed
        : undefined;
};
const trimmedNonEmptyString = (fieldName) => z
    .string({ message: `${fieldName} is required` })
    .trim()
    .min(1, `${fieldName} is required`);
const optionalTrimmedString = z
    .string()
    .trim()
    .nullish()
    .transform(value => (value && value.length > 0 ? value : undefined));
const optionalEscandallosQualification = z
    .string()
    .trim()
    .nullish()
    .transform(value => normalizeEscandallosQualification(value));
export const CreateMetaFormLeadRequestSchema = z.object({
    phone: trimmedNonEmptyString('phone'),
    name: trimmedNonEmptyString('name'),
    utm_source: optionalTrimmedString,
    utm_medium: optionalTrimmedString,
    utm_campaign: optionalTrimmedString,
    utm_term: optionalTrimmedString,
    utm_content: optionalTrimmedString,
    meta_lead_id: trimmedNonEmptyString('meta_lead_id'),
    ad_id: optionalTrimmedString,
    escandallosQualification: optionalEscandallosQualification,
    createdAt: z.unknown().nullish(),
    landing_page: z.unknown().nullish(),
});
//# sourceMappingURL=createMetaFormLeadSchema.js.map